import { EmailConversationModel, parseEmailConvId } from "@jugl-web/rest-api";

type EmailConversationNameSource = {
  contact_info?: EmailConversationModel["contact_info"];
  user_name?: string;
  conv_id: string;
};

export const getEmailConversationContactName = (
  conversation: EmailConversationNameSource,
  { withEmailFallback = true }: { withEmailFallback?: boolean } = {}
): string => {
  const name = conversation.contact_info?.name || conversation.user_name || "";

  if (name) return name;

  return withEmailFallback ? parseEmailConvId(conversation.conv_id).email : "";
};
